import React from 'react'
import { Redirect } from 'react-router-dom'

interface AuthorizedViewProps {
  clientPermissions?: string[]
  authorizedPermissions?: string[]
  failureRedirect: string
  isFeatureFlagPresent: boolean
}

const AuthorizedView: React.FunctionComponent<AuthorizedViewProps> = ({
  clientPermissions,
  authorizedPermissions = [],
  failureRedirect,
  isFeatureFlagPresent = true,
  children,
}) => {
  const isNotAuthorized = !authorizedPermissions?.every((perm) =>
    clientPermissions?.includes(perm)
  )

  if (!clientPermissions || isNotAuthorized || !isFeatureFlagPresent) {
    return <Redirect to={failureRedirect} />
  } else {
    return <>{children}</>
  }
}

export default AuthorizedView
